/**
 * Commissioned Machines Redux Slice
 * Manages state for commissioned physical machines (NVIDIA DGX, Jetson, etc.)
 */

const initialState = {
    machines: [],
    loading: false,
    error: null,
    selectedMachine: null,
    commissioningProgress: null
};

// Action types
export const FETCH_MACHINES_START = 'commissionedMachines/FETCH_MACHINES_START';
export const FETCH_MACHINES_SUCCESS = 'commissionedMachines/FETCH_MACHINES_SUCCESS';
export const FETCH_MACHINES_ERROR = 'commissionedMachines/FETCH_MACHINES_ERROR';
export const CREATE_MACHINE_SUCCESS = 'commissionedMachines/CREATE_MACHINE_SUCCESS';
export const UPDATE_MACHINE_SUCCESS = 'commissionedMachines/UPDATE_MACHINE_SUCCESS';
export const DELETE_MACHINE_SUCCESS = 'commissionedMachines/DELETE_MACHINE_SUCCESS';
export const SET_SELECTED_MACHINE = 'commissionedMachines/SET_SELECTED_MACHINE';
export const SET_COMMISSIONING_PROGRESS = 'commissionedMachines/SET_COMMISSIONING_PROGRESS';
export const CLEAR_ERROR = 'commissionedMachines/CLEAR_ERROR';

// Reducer
const commissionedMachinesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MACHINES_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_MACHINES_SUCCESS:
            return {
                ...state,
                loading: false,
                machines: action.payload,
                error: null
            };
        case FETCH_MACHINES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case CREATE_MACHINE_SUCCESS:
            return {
                ...state,
                machines: [action.payload, ...state.machines]
            };
        case UPDATE_MACHINE_SUCCESS:
            return {
                ...state,
                machines: state.machines.map(m =>
                    m._id === action.payload._id 
                        ? { ...m, ...action.payload }  // Merge with existing machine data
                        : m
                )
            };
        case DELETE_MACHINE_SUCCESS:
            return {
                ...state,
                machines: state.machines.filter(m => m._id !== action.payload)
            };
        case SET_SELECTED_MACHINE:
            return {
                ...state,
                selectedMachine: action.payload
            };
        case SET_COMMISSIONING_PROGRESS:
            return {
                ...state,
                commissioningProgress: action.payload
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};

export default commissionedMachinesReducer;
